import script from "./ProfileDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProfileDialog.vue?vue&type=style&index=0&id=4812d590&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4812d590"]])

export default __exports__